import {
  AttachMoney,
  Build,
  Business,
  Gavel,
  HistoryEdu,
  LocalOffer,
  Person,
  Sell,
  SvgIconComponent,
  Work,
} from '@mui/icons-material';

export type ProfessionalInsightSectionKey =
  | 'ownerSituation'
  | 'valueSnapshot'
  | 'improvementHistory'
  | 'liensAndFilings';

export type ProfessionalInsightSectionConfig = {
  key: ProfessionalInsightSectionKey;
  title: string;
  Icon: SvgIconComponent;
  reportAnchor: string;
};

export const PROFESSIONAL_INSIGHT_SECTIONS: ProfessionalInsightSectionConfig[] =
  [
    {
      key: 'ownerSituation',
      title: 'Owner Situation',
      Icon: Person,
      reportAnchor: '#possible-owners-section',
    },
    {
      key: 'valueSnapshot',
      title: 'Value Snapshot',
      Icon: AttachMoney,
      reportAnchor: '#property-valuation-section',
    },
    {
      key: 'improvementHistory',
      title: 'Improvement History',
      Icon: Work,
      reportAnchor: '#building-permits-section',
    },
    {
      key: 'liensAndFilings',
      title: 'Liens & Filings',
      Icon: HistoryEdu,
      reportAnchor: '#liens-section',
    },
  ];

const TAG_ICON_RULES: { match: RegExp; Icon: SvgIconComponent }[] = [
  { match: /motivated|seller|price/i, Icon: Sell },
  { match: /need work|repair|permit|roof/i, Icon: Build },
  { match: /investor|absentee|rental/i, Icon: Business },
  { match: /lien|foreclosure|distress|tax/i, Icon: Gavel },
  { match: /sale|sold|equity/i, Icon: Sell },
];

export function getTagIcon(tag: string): SvgIconComponent {
  const rule = TAG_ICON_RULES.find(({ match }) => match.test(tag));
  return rule?.Icon ?? LocalOffer;
}
